<header>
  <div id="admin-bar" *ngIf="isMmcUser">
    <app-admin-bar></app-admin-bar>
  </div>

  <div id="user-bar">
    <div class="header-title" [routerLink]="['dashboard']">
      <div [ngClass]="{ 'c-white': whiteTitle }">Venue <span [ngClass]="whiteTitle ? 'c-white': 'c-blue-primary'">Workspace.</span></div>
    </div>
    <div class="account-wrapper">
      <!-- <div class="btn-group" dropdown [isAnimated]="true"> -->
      <div class="btn-group" dropdown #userMenu="bs-dropdown" [insideClick]="true" (onHidden)="showLanguages = false">
        <button
          id="button-animated"
          dropdownToggle
          class="account-toggle dropdown-toggle"
          type="button"
          aria-controls="dropdown-animated">
          <!-- Button dropdown <span class="caret"></span> -->
          <div class="user-logo">
            <span>{{ userInitials }}</span>
          </div>
          <div class="user-name">
            <span>{{ isUserLogged?.name }}</span>
          </div>
          <img src="assets/img/icons/arrow-down-bold-black.svg" alt="arrow-down-bold-black icon" />
        </button>
        <div
          id="dropdown-animated"
          *dropdownMenu
          class="account-options dropdown-menu dropdown-menu-right"
          role="menu"
          aria-labelledby="button-animated">
          <!-- Both views stay in the DOM: removing the clicked element makes the dropdown take it as an outside click. -->
          <div class="menu-view" [hidden]="showLanguages">
            <div class="menu-header">
              <p class="user-full-name">{{ isUserLogged?.name }}</p>
              <p class="organization-name">{{ isUserLogged?.client?.name }}</p>
            </div>
            <button type="button" class="menu-row language-row" role="menuitem" (click)="showLanguages = true">
              <span>{{ currentLang | uppercase }} | {{ langNames[currentLang] }}</span>
              <img class="chevron-right" src="assets/img/icons/arrow-left-bold-black.svg" alt="" />
            </button>
            <button type="button" class="menu-row logout-row" role="menuitem" (click)="logout()">
              <img src="assets/img/icons/logout-icon.svg" alt="" />
              <span>{{ 'layout.userMenu.logout' | translate }}</span>
            </button>
          </div>

          <div class="menu-view" [hidden]="!showLanguages">
            <button type="button" class="menu-header language-header" (click)="showLanguages = false">
              <img src="assets/img/icons/arrow-left-bold-black.svg" alt="" />
              <span>{{ 'layout.userMenu.selectLanguage' | translate }}</span>
            </button>
            <button
              *ngFor="let lang of languages"
              type="button"
              class="menu-row language-option"
              role="menuitemradio"
              [class.selected]="lang === currentLang"
              [attr.aria-checked]="lang === currentLang"
              (click)="chooseLanguage(lang); userMenu.hide()">
              <span>{{ lang | uppercase }} | {{ langNames[lang] }}</span>
              <svg *ngIf="lang === currentLang" class="check" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M 20.292969 5.2929688 L 9 16.585938 L 4.7070312 12.292969 L 3.2929688 13.707031 L 9 19.414062 L 21.707031 6.7070312 L 20.292969 5.2929688 z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- <div class="account-toggle">
        <div class="user-logo">
          <span>{{ userInitials }}</span>
        </div>
        <img src="assets/img/icons/arrow-down-bold-black.svg" alt="arrow-down-bold-black icon">
      </div>
      <div class="account-options shadow-sm">
        <button class="account-options-btn" (click)="changepassword()">Update password</button>
        <button class="account-options-btn" (click)="logout()">Logout</button>
      </div> -->
    </div>
  </div>
</header>

<!-- <header *ngIf="currentUrl !== '/login'" id="common-header">
  <div class="header-wrapper">
    <div class="h-100 d-flex align-items-center">
      <div class="logo-wrapper">
        <div>
          <a [routerLink]="['dashboard']">
            <img src="/assets/img/3ddv/3ddv.png" alt="Logo 3ddv" height="30" />
          </a>
        </div>
      </div>
      <div class="date-container">
        <span>{{ currentDate }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <div class="login-wrapper">
        <div class="vertical-line"></div>
        <div *ngIf="isUserLogged !== undefined && currentUrl !== '/login'" class="d-flex align-items-center">
          <div class="help-icon" (click)="changepassword()" style="font-size: 21px"><i class="fa fa-user"></i></div>
          <div class="vertical-line"></div>
          <div class="login-icon" (click)="logout()">
            <img class="header-icon" src="/assets/img/header/off.svg" alt="logout" />
          </div>
        </div>
      </div>
    </div>
    <div class="user-wrapper" *ngIf="isUserLogged">
      <span>
        <span class="dark-gray">{{ 'header.workspace.welcome' | translate }}</span>
        <span class="light-gray text-uppercase"> {{ isUserLogged.user.name | titlecase }} </span>
      </span>
    </div>
  </div>
  <app-breadcrumbs [breadcrumbs]="[]"></app-breadcrumbs>
</header> -->
